import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Hash navigation — wait a frame so the new route has mounted and
      // its sections are in the DOM. Use "auto" (instant) to avoid racing
      // with section-tracking observers that rewrite the hash during a
      // smooth scroll animation.
      const id = hash.substring(1);
      const tryScroll = (attempt = 0) => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "auto", block: "start" });
        } else if (attempt < 10) {
          setTimeout(() => tryScroll(attempt + 1), 30);
        }
      };
      tryScroll();
    } else {
      // Regular navigation - scroll to top
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
